import React, { forwardRef } from 'react';
import '../../css/Common.css';
import ResearchReportList from './ResearchReportList';
import CloseSidebarBtn from '../CloseSidebarBtn';

const ResearchSidebar = forwardRef(({ reportList, onReportSelect, selectedReportId, closeSidebarClick, onDeleteButtonClick, showMenu }, ref) => {
    return (
        <div ref={ref} className={`research-sidebar ${showMenu ? '!flex' : ''} z-[2000]`}>
            <CloseSidebarBtn onClick={closeSidebarClick}/>
            <div id="title">Insight Note<span className="add-small"></span><span className="close-sidebar">✕</span></div>
            <ResearchReportList 
                reportList={reportList} 
                selectedReportId={selectedReportId} 
                onReportSelect={onReportSelect} 
                onDeleteButtonClick={onDeleteButtonClick}
            />
        </div>
    );
})

export default ResearchSidebar;
